// アカウント予算最大値(10億円)
export const MAX_ACCOUNT_BUDGET = 1000000000

export type Budget = {
  budgetMonth: string,
  budgetAmount: number,
  status: number,
  platformBudgets: PlatformBudget[],
}

export type PlatformBudget = {
  platformId: number,
  platformName: string,
  state: number,
  imageUrl: string,
  budgetMonth: string,
  budgetAmount: number,
}

export type BudgetReq = {
  accountgroupId: number,
  budgetMonth1: string,
  budgetAmount: number,
  platformBudgets: PlatformBudgetReq[],
}

export type PlatformBudgetReq = {
  platformId: number,
  budgetMonth: string,
  budgetAmount: number,
}

// 予算管理モデル
// 【広告主アカウントメニュー予算で必要なカラム】
export type Amount = {
  budgetNo: number,
  budgetName: string,
  budgetAmount: number,
  nextBudgetAmount: number,
  menuId: number,
  platformAccountId: string,
  // message: string,
}
export type AmountMessage = {
  budgetNo: number,
  budgetName: string,
  budgetAmount: number,
  nextBudgetAmount: number,
  menuId: number,
  platformAccountId: string,
  message: string,
}
// 【広告主アカウント月額予算】
export type AccountBudget = {
  accountId: number,
  accountName: string,
  budgetMonth: string,
  budgetAmount: number,
  nextBudgetAmount: number,
  status: number,
  trackerId: string,
  accountgroupId: number,
  accountgroupName: string,
  billingId: number,
  billingName: string,
  creditLimitAmount: number,
  amounts: AmountMessage[],
}
// 【広告主アカウントメニュー予算】
export type AccountMenuBudget = {
  accountId: number,
  accountName: string,
  budgetMonth: string,
  campaignKindId: number,
  menuId: number,
  nextBudgetAmount: number,
  useStatus: number,
  platformBudget1Amount: number,
  platformBudget2Amount: number,
}
// 【広告主アカウント月額予算更新リクエスト】
export type BudgetPutReq = {
  budgetAmount: number,
  nextBudgetAmount:number,
}
// 【広告主アカウントメニュー月額予算更新リクエスト】
export type BudgetMenuPutReq = {
  amounts: Amount[],
}
// 【広告主アカウント月額予算表示データ】
export type AccountBudgetDisplay = {
  accountgroupId: number,
  accountgroupName: string,
  accountId: number,
  accountName: string,
  budgetAmount: number,
  budgetAmount1: number,
  budgetAmount2: number,
  menuAmount: MenuAmountInfo[],
  menuAmountDisplay: number[],
  message: string,
}
// 【広告主アカウントメニュー予算チェックで必要なカラム】
export type AmountCheck = {
  budgetNo: number,
  budgetName: string,
  budgetAmount: number,
  nextBudgetAmount: number,
  menuId: number,
  platformAccountId: string,
  budgetAmountMin: number,
  nextBudgetAmountMin: number,
  budgetAmountOld: number,
  nextBudgetAmountOld: number,
}
// 【広告主アカウントメニュー月額予算チェックリクエスト】
export type BudgetMenuCheckReq = {
  amounts: AmountCheck[],
}
// 【予算表示データ(メニュー単位)】
export type MenuAmountInfo = {
  budgetNo: number,
  menuId: number,
  platformAccountId: string,
  amount: number,
  amount1: number,
  amount2: number,
  message: string,
}
// 【アカウント別予算実績情報(アカウント個別)】
export type AccountBudgetCostPerformances = {
  accountId: number,
  budgetMonth: string,
  budgetAmount: number,
  nextBudgetAmount: number,
  cost: number,
  budgetCostPerformance: BudgetCostPerformance[],
}
// 【アカウント別予算実績情報(メニュー単位)】
export type BudgetCostPerformance = {
  budgetNo: number,
  budgetName: string,
  budgetMonth: string,
  budgetAmount: number,
  nextBudgetAmount: number,
  cost: number,
}

// 0値実績データ取得
export const ZeroPerformanceData:AccountBudgetCostPerformances = {
  accountId: 0,
  budgetMonth: "",
  budgetAmount: 0,
  nextBudgetAmount: 0,
  cost: 0,
  budgetCostPerformance: 
  [
    {
      budgetNo: 10,
      budgetName: "",
      budgetMonth: "",
      budgetAmount: 0,
      nextBudgetAmount: 0,
      cost: 0,
    },
    {
      budgetNo: 21,
      budgetName: "",
      budgetMonth: "",
      budgetAmount: 0,
      nextBudgetAmount: 0,
      cost: 0,
    },
    {
      budgetNo: 22,
      budgetName: "",
      budgetMonth: "",
      budgetAmount: 0,
      nextBudgetAmount: 0,
      cost: 0,
    },
    {
      budgetNo: 30,
      budgetName: "",
      budgetMonth: "",
      budgetAmount: 0,
      nextBudgetAmount: 0,
      cost: 0,
    },
  ],
}

// Zeus配信種別月額予算
export type ZeusBudgetDetail = {
  deliveryType: number,
  deliveryTypeName: string,
  budget: number,
  nextBudget: number,
}
// Zeus配信種別月額予算リスト
export type ZeusBudgets = {
  platformAccountId: number,
  zeusBudgets: ZeusBudgetDetail[],
}
// Zeus配信種別月額予算変更リクエスト
export type RequestZeusBudgets = {
  budget: number,
  zeusBudgets: ZeusBudgetDetail[],
}
